import React from "react";
import DOMPurify from "dompurify";

// Lightweight markdown renderer (headings, bold, lists, code, paragraphs)
export function Markdown({ text = "", className = "" }) {
  const clean = DOMPurify.sanitize(render(text), {
    ALLOWED_TAGS: ["h1", "h2", "h3", "p", "ul", "li", "strong", "em", "code", "br"],
    ALLOWED_ATTR: [],
  });
  return <div className={`prose-notebook ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
}

function esc(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function inline(s) {
  s = esc(s);
  s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  s = s.replace(/`(.+?)`/g, "<code>$1</code>");
  s = s.replace(/\*(.+?)\*/g, "<em>$1</em>");
  return s;
}

function render(text) {
  const lines = String(text).split("\n");
  let out = [];
  let inList = false;
  const closeList = () => { if (inList) { out.push("</ul>"); inList = false; } };
  for (let raw of lines) {
    const line = raw.trimEnd();
    if (/^#{3}\s/.test(line)) { closeList(); out.push(`<h3>${inline(line.replace(/^#{3}\s/, ""))}</h3>`); }
    else if (/^#{2}\s/.test(line)) { closeList(); out.push(`<h2>${inline(line.replace(/^#{2}\s/, ""))}</h2>`); }
    else if (/^#\s/.test(line)) { closeList(); out.push(`<h1>${inline(line.replace(/^#\s/, ""))}</h1>`); }
    else if (/^[-*]\s/.test(line)) {
      if (!inList) { out.push("<ul>"); inList = true; }
      out.push(`<li>${inline(line.replace(/^[-*]\s/, ""))}</li>`);
    } else if (line.trim() === "") { closeList(); }
    else { closeList(); out.push(`<p>${inline(line)}</p>`); }
  }
  closeList();
  return out.join("\n");
}
